import { render, staticRenderFns } from "./displayTable.vue?vue&type=template&id=0af206be&"
import script from "./displayTable.vue?vue&type=script&lang=ts&"
export * from "./displayTable.vue?vue&type=script&lang=ts&"
import style0 from "./displayTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports